import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import CompletePage from "./CompletePage";



const s_key = process.env.REACT_APP_STRIPE_KEY;

const stripePromise = loadStripe(s_key);



export function Checkout({cartItems , total}) {
  const [clientSecret, setClientSecret] = useState("");
  const [dpmCheckerLink, setDpmCheckerLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  const backEndUrl = process.env.REACT_APP_STRIPE_BACKEND_PAYMENT_URL;
  console.log("backEndUrl is here", backEndUrl)
  // console.log("the URL ::",backEndUrl);
  // console.log("the s_key ::",s_key);
  console.log("cartItems is here", cartItems)


  const createPaymentIntent = async () => {
    setIsLoading(true);
    console.log("createPaymentIntent is here")
    console.log("cartItems is here", cartItems)
    console.log("total is here", total)
    try {
  
      const get_Stripe_Netlify_Serverless = await fetch("/.netlify/functions/getStripe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          request_type: "create_payment_intent",
           items:{
                 cartItems, 
                 amount: parseInt(total) 
                }})
      });
      const data = await get_Stripe_Netlify_Serverless.json()
      console.log("data is here", data)
      setClientSecret(data.clientSecret);
      setDpmCheckerLink(data.dpmCheckerLink);
   
    } catch (error) {
      console.error("Error creating payment intent:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckout = () => {
    if (!clientSecret) {
      createPaymentIntent();
    }
  };

  const appearance = {
    theme: 'stripe',
  };
  
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {!clientSecret ? (
        <button 
          className="bg-blue-500 text-white px-4 py-2 rounded" 
          onClick={handleCheckout}
          disabled={isLoading}
        >
          {isLoading ? 'Processing...' : 'Proceed to Checkout'}
        </button>
      ) : (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm dpmCheckerLink={dpmCheckerLink} />
          <CompletePage />
        </Elements>
      )}
    </div>
  );
}